import { documentToDocumentType, publishedToPrivacyLevel, schemaVersionNameToProductType, unifiedPrivacyToPrivacyLinkAccess } from '../../../utils/mappings';
export const documentTypeSelector = state => documentToDocumentType(state.document.value);
const privacyLevelSelector = state => publishedToPrivacyLevel(state.unifiedPrivacy.value);
const privacyLinkAccessSelector = state => unifiedPrivacyToPrivacyLinkAccess(state.unifiedPrivacy.value);
const privacyPublicSelector = state => {
  var _state$unifiedPrivacy;
  return (_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.is_published;
};
const privacyReusableSelector = state => {
  var _state$unifiedPrivacy2;
  return (_state$unifiedPrivacy2 = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy2 === void 0 ? void 0 : _state$unifiedPrivacy2.is_reusable;
};
export const productTypeSelector = state => {
  var _state$document$value;
  return schemaVersionNameToProductType((_state$document$value = state.document.value) === null || _state$document$value === void 0 ? void 0 : _state$document$value.schema_version_name);
};
export const setPrivacyParamsSelector = state => ({
  document_oid: state.documentOid,
  document_type: documentTypeSelector(state),
  privacy_level: privacyLevelSelector(state),
  privacy_link_access: privacyLinkAccessSelector(state),
  privacy_public: privacyPublicSelector(state),
  privacy_reusable: privacyReusableSelector(state)
});